import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ProductoStats() {
  const temas = ['Familia', 'Emociones', 'Vida cotidiana', 'Salud', 'Gramática', 'Cultura Sorda', 'Situaciones reales'];
  const formatos = ['Digital', 'PDF', 'Celular', 'Tablet', 'PC', 'Imprimible', '100% argentino', 'Edición 2026'];
  return <section className="bg-lsa-dark py-12 px-5" data-id="element-254">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="max-w-md mx-auto bg-lsa-cyan text-lsa-deep rounded-3xl p-7 shadow-2xl shadow-lsa-cyan/20" data-id="element-255">
        {/* Badge */}
        <div className="flex justify-center mb-6" data-id="element-256">
          <span className="inline-flex items-center gap-2 bg-white/20 text-lsa-deep rounded-full px-4 py-1.5 text-[12px] font-bold uppercase tracking-wide" data-id="element-257">
            <Check size={15} strokeWidth={3} data-id="element-258" /> Sistema N°1 en Argentina
          </span>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 divide-x divide-lsa-deep/15 mb-7 text-center" data-id="element-259">
          <div className="px-2" data-id="element-260">
            <div className="text-[40px] font-extrabold leading-none" data-id="element-261">+2000</div>
            <div className="text-[12px] font-bold uppercase tracking-wider mt-1 opacity-70" data-id="element-262">
              Señas
            </div>
          </div>
          <div className="px-2" data-id="element-263">
            <div className="text-[40px] font-extrabold leading-none" data-id="element-264">7</div>
            <div className="text-[12px] font-bold uppercase tracking-wider mt-1 opacity-70" data-id="element-265">
              Tomos
            </div>
          </div>
        </div>

        {/* Topics */}
        <p className="text-center font-bold text-[14px] leading-relaxed mb-6 px-1" data-id="element-266">
          {temas.map((tema, i) => <Fragment key={i} data-id="element-267">
              {tema}
              {i < temas.length - 1 && <span className="opacity-40 mx-1.5" data-id="element-268">·</span>}
            </Fragment>)}
        </p>

        {/* Format pills */}
        <div className="flex flex-wrap justify-center gap-2" data-id="element-269">
          {formatos.map((f, i) => <span key={i} className="bg-white/20 text-lsa-deep rounded-full px-3.5 py-1.5 text-[12px] font-semibold" data-id="element-270">
              {f}
            </span>)}
        </div>
      </motion.div>
    </section>;
}